/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCar48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M23.808 29.959h.005c9.441 0 15.441 0 22.37-1.35l-.429 4.247c-6.212 1.277-21.726 1.261-21.943 1.26-.217.001-15.732.017-21.944-1.26l-.429-4.247c6.93 1.35 12.93 1.35 22.37 1.35zM29.755 16l2.613 1.578c-.13 1.066-.693 1.505-1.613 1.422 0 0-2.367-1.41-6.943-1.422C19.346 17.59 16.867 19 16.867 19c-1.426-.041-2.32-.516-1.5-1.5l2.5-1.5h11.887z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M36.254 37.17V32'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M43.863 16.235l-1.475 1.648'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M32.864 17.5c-.074.805-.653 1.634-1.997 2.5M23.813 5.5c8.09 0 12.246.994 13.513 1.364.27.096.478.317.558.593.599 2.077 3.031 10.538 3.031 10.538'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M41.254 37c3.168-.507 3.97-1.36 4.203-2.41v6.916c0 .825-.669 1.494-1.494 1.494h-2.602a1.494 1.494 0 01-1.494-1.494V37h1.387zM6.367 37c-3.168-.507-3.97-1.36-4.203-2.41v6.916c0 .825.67 1.494 1.494 1.494H6.26c.825 0 1.494-.669 1.494-1.494V37H6.367z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M11.367 37.17V32M45.788 30.5s-4.98 1-21.92 1c-16.942 0-22.035-1-22.035-1'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M3.758 16.235l1.475 1.648'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M42.754 21.66c-1.656 0-3 1.343-3 3 0 1.655 1.344 3 3 3s3-1.345 3-3c0-1.657-1.344-3-3-3zm-37.887 0c1.656 0 3 1.343 3 3 0 1.655-1.344 3-3 3-1.655 0-3-1.345-3-3 0-1.657 1.345-3 3-3zm5.551.62a.236.236 0 01.234-.28H36.97a.239.239 0 01.234.28l-.843 4.634a.713.713 0 01-.701.586H11.963a.713.713 0 01-.702-.585l-.843-4.635v0zm-7.456-9.955a1.751 1.751 0 010 3.5 1.751 1.751 0 010-3.5zm41.697 0a1.75 1.75 0 10.002 3.502 1.75 1.75 0 00-.002-3.502z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M15.728 16.599a2.493 2.493 0 011.615-.594C20.04 16 27.58 16 30.278 16a2.5 2.5 0 011.619.595c.438.417.948.893.967.905 4.822.193 8.03.571 10.15.963a4.442 4.442 0 013.572 4.878c-.36 3.129-.832 7.165-.832 7.165v2.742a3 3 0 01-2.742 2.99c-3.772.294-11.032.762-19.2.762h-.004c-8.167 0-15.427-.468-19.2-.764a2.999 2.999 0 01-2.74-2.987v-2.743l-.838-7.164a4.448 4.448 0 013.577-4.884c2.12-.387 5.328-.765 10.15-.958.019-.012.53-.488.97-.901z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M14.757 17.5c.074.805.653 1.634 1.997 2.5M23.808 5.5c-8.09 0-12.246.994-13.512 1.364a.89.89 0 00-.559.593l-3.03 10.538M15.423 24.75h16.78M36.422 17.5c0-2.121-2.24-3.844-5-3.844-1.567 0-2.966.555-3.883 1.423l-.77.803'
      />
    </svg>
  );
}

export default SvgCar48;
